import { render, staticRenderFns } from "./dataPosterFull.vue?vue&type=template&id=5394651f"
import script from "./dataPosterFull.vue?vue&type=script&lang=js"
export * from "./dataPosterFull.vue?vue&type=script&lang=js"
import style0 from "./dataPosterFull.vue?vue&type=style&index=0&id=5394651f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports